export interface Volume {
  title: string
  items: string[]
  border: string
}

export const volumes: Volume[] = [
  {
    title: 'Volumen 1 — El Mapa del SIBO',
    items: [
      'Entendés qué está pasando realmente en tu intestino delgado',
      'Distinguís los tres tipos de sobrecrecimiento y por qué no se tratan igual',
      'Identificás los errores cotidianos que alimentan la fermentación',
      'Arrancás con dirección total desde el Día 1',
    ],
    border: 'border-blue-400/30',
  },
  {
    title: 'Volumen 2 — Fase Limpieza: 14 días',
    items: [
      'Aplicás un protocolo ordenado para bajar la carga bacteriana',
      'Conocés los antimicrobianos botánicos más estudiados y cómo se combinan',
      'Sabés qué esperar cada semana y cómo atravesar los días difíciles',
      'Reducís distensión y gases sin improvisar',
    ],
    border: 'border-green-400/30',
  },
  {
    title: 'Volumen 3 — Combustible Bajo en Fermentación',
    items: [
      'Descubrís qué alimentos están alimentando tus síntomas',
      'Sabés qué comer y qué evitar sin adivinar en cada comida',
      'Usás ingredientes de cualquier supermercado argentino',
      'Avanzás con un plan de transición de 21 días, comida por comida',
    ],
    border: 'border-amber-400/30',
  },
  {
    title: 'Volumen 4 — El Botiquín Digestivo',
    items: [
      'Entendés para qué sirve cada enzima, probiótico y amargo digestivo',
      'Sabés en qué momento del protocolo conviene sumar cada cosa',
      'Conocés interacciones clave para conversar con tu equipo médico',
      'Dejás de comprar suplementos sueltos que no se usan entre sí',
    ],
    border: 'border-red-400/30',
  },
  {
    title: 'Volumen 5 — Reparación y Cero Recaídas',
    items: [
      'Recuperás la motilidad intestinal, la causa más común de recaída',
      'Ordenás estrés, sueño y horarios de comida con pasos simples',
      'Reintroducís alimentos sin volver al punto de partida',
      'Tenés un plan de mantenimiento para sostener los resultados',
    ],
    border: 'border-yellow-400/30',
  },
]

export const included: string[] = [
  'Plan diario listo para arrancar hoy',
  'Cronograma de implementación de 21 días',
  'Planilla de registro de síntomas y comidas',
  'Checklists imprimibles por fase',
]

export interface Bonus {
  number: string
  title: string
  details: string[]
  value: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Radar de Gatillos Digestivos™',
    details: [
      'Detectás en 7 días qué comidas disparan la distensión',
      'Registrás comida, sueño y estrés en minutos por día',
      'Llevás datos claros a cada consulta médica',
    ],
    value: '$12.000',
  },
  {
    number: '02',
    title: 'Despensa Baja en Fermentación',
    details: [
      'Sabés exactamente qué poner en el changuito',
      'Identificás endulzantes y aditivos ocultos en etiquetas',
      'Hacés reemplazos simples sin resignar sabor',
    ],
    value: '$10.000',
  },
  {
    number: '03',
    title: 'Recetario Vientre Liviano',
    details: [
      '30 recetas aptas para la fase de limpieza',
      'Desayunos, almuerzos y cenas en menos de 25 minutos',
      'Opciones para llevar al trabajo sin volver a hincharte',
    ],
    value: '$9.000',
  },
  {
    number: '04',
    title: 'Carpeta Médica Digestiva',
    details: [
      'Organizás test de aliento, análisis y estudios en un lugar',
      'Registrás medicación, síntomas y tratamientos con claridad',
      'Llegás a cada consulta con preguntas preparadas',
    ],
    value: '$11.000',
  },
  {
    number: '05',
    title: 'SOS Distensión en 20 Minutos',
    details: [
      'Aplicás una secuencia de alivio cuando el abdomen ya está duro',
      'Usás respiración diafragmática y masaje abdominal guiado',
      'Sabés qué hacer después de una comida fuera de plan',
    ],
    value: '$10.000',
  },
]
